import React from 'react';
import styled from 'styled-components';
import gdprLogo from '../assets/GDPR.png';
import euAiActLogo from '../assets/EU_AI_Act_logo_main.png';
import nextheralogopreto from '../assets/nextheralogo.png';
import prrLogos from '../assets/prr.jpeg';

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <LogoContainer>
            <LogoImage src={nextheralogopreto} alt="NexThera" />
          </LogoContainer>
          <Description>
            The right therapy. At the right time.
          </Description>
          <GdprContainer>
            <GdprImage src={gdprLogo} alt="GDPR Compliant" />
            <EuAiActImage src={euAiActLogo} alt="EU AI Act Compliant" />
          </GdprContainer>
          <SocialLinks>
            <SocialLink href="https://www.linkedin.com/company/nexthera/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              LinkedIn
            </SocialLink>
            <SocialLink href="https://x.com/nextherapeutics" target="_blank" rel="noopener noreferrer" aria-label="Twitter/X">
              Twitter/X
            </SocialLink>
          </SocialLinks>
        </FooterSection>

        <FooterSection>
          <SectionTitle>Company</SectionTitle>
          <FooterLink href="#about">About Us</FooterLink>
          <FooterLink href="#team">The Team</FooterLink>
          <FooterLink href="#news">News</FooterLink>
          <FooterLink href="#contact">Contact Us</FooterLink>
        </FooterSection>

        <FooterSection>
          <SectionTitle>Legal</SectionTitle>
          <FooterLink href="/terms">Terms & Conditions</FooterLink>
          <FooterLink href="/privacy">Privacy Policy</FooterLink>
          <FooterLink href="/cookies">Cookie Policy</FooterLink>
        </FooterSection>

        <FooterSection>
          <SectionTitle>Reach Us</SectionTitle>
          <ContactInfo>
            <ContactLine>NEXTHERAPEUTICS, LDA</ContactLine>
            <ContactLine>Rua Junta de Freguesia, 194, CI3</ContactLine>
            <ContactLine>Arouca, Portugal</ContactLine>
            <ContactLine>
              Email: <a href="mailto:mail@nexthera.tech">mail@nexthera.tech</a>
            </ContactLine>
          </ContactInfo>
        </FooterSection>
      </FooterContent>
      
      <FundingSection>
        <FundingLink
          href="https://recuperarportugal.gov.pt"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Plano de Recuperação e Resiliência - Recuperar Portugal"
        >
          <FundingImage src={prrLogos} alt="Cofinanciado pelo PRR - Plano de Recuperação e Resiliência, República Portuguesa e Financiado pela União Europeia NextGenerationEU" />
        </FundingLink>
      </FundingSection>

      <FooterBottom>
        <CopyrightText>
          © 2025 NexThera. All Rights Reserved.
        </CopyrightText>
      </FooterBottom>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 50%, #94a3b8 100%);
  color: #374151;
  padding: 40px 20px 20px;
  position: relative;
  bottom: 0;
  width: 100%;
  font-size: 0.9rem;
  box-shadow: 0 -5px 30px rgba(0, 0, 0, 0.1);
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const LogoContainer = styled.div`
  margin-bottom: 10px;
`;

const LogoImage = styled.img`
  height: 70px;
  width: auto;
`;

const Description = styled.p`
  margin: 0 0 20px 0;
  color: #64748b;
  line-height: 1.5;
`;

const GdprContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  justify-content: flex-start;
  margin-left: -40px;
  padding-left: 0;
`;

const GdprImage = styled.img`
  height: 60px;
  width: auto;
  opacity: 0.8;
  transition: opacity 0.3s ease;
  
  &:hover {
    opacity: 1;
  }
`;

const EuAiActImage = styled.img`
  height: 45px;
  width: auto;
  opacity: 0.8;
  transition: opacity 0.3s ease;
  
  &:hover {
    opacity: 1;
  }
`;

const SectionTitle = styled.h4`
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 15px 0;
  color: #2094F1;
`;

const FooterLink = styled.a`
  color: #64748b;
  text-decoration: none;
  margin-bottom: 8px;
  transition: color 0.3s ease;
  cursor: pointer;

  &:hover {
    color: #2094F1;
  }
`;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const ContactLine = styled.p`
  margin: 0 0 5px 0;
  color: #64748b;
  line-height: 1.4;

  a {
    color: #2094F1;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 15px;
`;

const SocialLink = styled.a`
  color: #64748b;
  font-size: 0.9rem;
  text-decoration: none;
  transition: color 0.3s ease;
  cursor: pointer;

  &:hover {
    color: #AF54AE;
  }
`;

const FundingSection = styled.div`
  border-top: 1px solid #94a3b8;
  padding-top: 25px;
  margin: 0 auto 10px;
  max-width: 1200px;
  display: flex;
  justify-content: center;
`;

const FundingLink = styled.a`
  display: inline-flex;
  background: #ffffff;
  padding: 15px 25px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease, transform 0.3s ease;

  &:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }
`;

const FundingImage = styled.img`
  height: 55px;
  width: auto;
  max-width: 100%;

  @media (max-width: 768px) {
    height: auto;
    width: 100%;
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid #94a3b8;
  padding-top: 20px;
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
`;

const CopyrightText = styled.p`
  margin: 0;
  color: #64748b;
`;

export default Footer;
